import InvisibleButton from 'components/InvisibleButton'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Forms from './components/Forms'
import { RegistrationContextProvider, RegistrationPath } from './hooks/useRegistration'
import * as Styles from './styles'

function RegistrationAssociation() {
  const [path, setPath] = useState<RegistrationPath>('patient')
  const { push } = useHistory()

  const handleGoToLogin = () => {
    push('/areaassociados')
  }

  return (
    <Styles.RegistrationContainer>
      <Styles.AlreadyHaveAccount>
        Já é associado?
        <InvisibleButton
          type="button"
          color="#00607f"
          style={{ textDecoration: 'underline', color: '#00607f' }}
          onClick={handleGoToLogin}>
          Faça login aqui.
        </InvisibleButton>
      </Styles.AlreadyHaveAccount>

      <Forms onGoBack={() => setPath('patient')} path={path} />
    </Styles.RegistrationContainer>
  )
}

export default function RegistrationAssociationWrapper() {
  return (
    <RegistrationContextProvider>
      <RegistrationAssociation />
    </RegistrationContextProvider>
  )
}
